<template>
    <BaseAccordion class="accordion gap-2" :unmount-on-hide="false" :accordion-ids="accordionIds">
        <template #expandIcon><i class="bi bi-plus text-xl" aria-hidden="true"></i></template>
        <template #collapseIcon><i class="bi bi-dash text-xl" aria-hidden="true"></i></template>
        <template v-for="id in accordionIds" :key="id" #[makeTriggerSlot(id)]>
            <slot :name="`trigger-${id}`"></slot>
        </template>
        <template v-for="id in accordionIds" :key="id" #[makeContentSlot(id)]>
            <div class="py-3">
                <slot :name="`content-${id}`"></slot>
            </div>
        </template>
    </BaseAccordion>
</template>

<script lang="ts">
export const makeTriggerSlot = (id: string) => `trigger-${id}`;
export const makeContentSlot = (id: string) => `content-${id}`;
</script>

<script setup lang="ts">
import BaseAccordion from "~vue/components/BaseAccordion.vue";

type ChatWidgetAccordionProps = {
    accordionIds: string[];
};

const { accordionIds } = defineProps<ChatWidgetAccordionProps>();
</script>

<style scoped>
@reference "../../../css/tailwind.css";
/* override base accordion styles */
.accordion:deep() {
    .item {
        @apply shadow-md;
    }
}
</style>
